export function imagePath(image) {
    return `http://backend-demo.glowthentic.store/${image}`;
}